import React from "react";
import { UICheckbox } from "components/ui";
import MobileACHParticipantsRow from "../MobileACHParticipantsRow";
import {TableItemContainer } from "components/shared";
import "./styles.css"; 

/**
 * @function MobileACHParticipantsTable
 * @return {React.Component}
 * @exported true
 * @description This is the main mobile table view for ACH Participants modal.
 */
export default function MobileACHParticipantsTable(props) {
    const participants = props.participants ?? [];
    const onParticipantRowChange = props.onParticipantRowChange ?? (() => {});
    const onSelectAllParticipantsCheckboxChange = props.onSelectAllParticipantsCheckboxChange ?? (() => {});

    const rows =participants.length>0? participants.reduce((acc, item) => {
        acc.push(
            <MobileACHParticipantsRow key={ item.id } participant={ item } onParticipantRowChange={ onParticipantRowChange } />
        );
        return acc;
    }, []):
    <div className="no-participant-row">
    <p className="text-center table-item-text-view">There are no participants.</p>
  </div>
 
    return (
        <div className="mobile-ach-participants-table">
            <MobileACHParticipantsTableHeader participants={ participants } onParticipantRowChange={ onParticipantRowChange }
                    onSelectAllParticipantsCheckboxChange={ onSelectAllParticipantsCheckboxChange } />
            { rows }
        </div>
    )
}

/**
 * @function MobileACHParticipantsTableHeader
 * @return {React.Component}
 * @exported false
 * @description This is the mobile table header used for MobileACHParticipantsTable component.
 */
function MobileACHParticipantsTableHeader(props) {
    const participants = props.participants ?? [];
    const onSelectAllParticipantsCheckboxChange = props.onSelectAllParticipantsCheckboxChange ?? (() => {});
    const allParticipantsAreSelected =participants.length >0 && participants.filter(item => item.isSelected === "true").length === participants.length;

    return (
        <div className="mobile-ach-participants-table-header">
            <div className="table-header-container flex-container flex-horizontal">
                <div className="set-width participant-checkbox">
                    <UICheckbox label="" value={ allParticipantsAreSelected } onChange={ onSelectAllParticipantsCheckboxChange } />
                </div>
            </div>
        </div>
    )
}